import { Button } from 'src/components/atoms';
import styled from 'styled-components';

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: 19px 20px;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
  gap: 20px;
  width: 100%;
`;

export const StyledBackButton = styled(Button)`
  min-width: auto;
`;

export const LeftSideWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  width: 50%;
`;

export const CaseTagsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 50%;
  justify-content: flex-end;
`;
